import { List, Stack, styled } from "@mui/material"
import { ReactComponent as EverDrivenLogo } from "assets/images/everDrivenLogoRGB.svg"

import { IStyledList } from "./MainDrawer.types"

export const StyledEverDrivenLogo = styled(EverDrivenLogo)(({ theme }) => ({
  height: theme.spacing(3)
}))

export const StyledList = styled(List)<IStyledList>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  paddingTop: theme.spacing(3)
}))

export const NavigationContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),

  [theme.breakpoints.up("md")]: {
    display: "none"
  }
}))
